import { Trash } from 'react-feather'
import styled from 'styled-components'

export const RemoveBatchButton = styled(Trash)`
    cursor: pointer;
`
